import * as React from 'react';

import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import type {EntitySummaryStatus} from 'nutshell-graphql-types';

import styles from './transcription-section.module.css';

type Props = {
    callHasEnded: boolean;
    summary?: string | null | undefined;
    summaryStatus?: EntitySummaryStatus | null | undefined;
};

export function SummarizeSection(props: Props) {
    let summaryBody;
    if (props.summaryStatus === 'ERRORED') {
        summaryBody = (
            <Body color='error' size='small'>
                There was an error generating the summary.
            </Body>
        );
    } else if (props.summaryStatus === 'COMPLETE') {
        summaryBody = <Body size='small'>{props.summary}</Body>;
    } else if (props.summaryStatus === 'LOADING' || props.summaryStatus == null) {
        // We need to default to the "LOADING" state because the summary
        // status may not have a value set yet
        summaryBody = (
            <>
                <Body size='small'>
                    {props.callHasEnded ? (
                        <LoadingText width={400} />
                    ) : (
                        'Summary will be generated after this conversation ends.'
                    )}
                </Body>
                <LoadingText width={480} />
            </>
        );
    } else {
        props.summaryStatus as never; // eslint-disable-line @typescript-eslint/no-unused-expressions
    }

    return (
        <StackLegacy spacing={4}>
            <Body size='small' isBold={true}>
                Summarization
            </Body>
            <div className={styles['section-wrapper']}>
                <div className='flex align-center gap-8'>
                    <AiSparkleNewIcon size={12} alignCenter={true} wrapWithDiv={false} />
                    <Body size='mini' isBold={true}>
                        AI Summary
                    </Body>
                </div>
                {summaryBody}
            </div>
        </StackLegacy>
    );
}
